module.exports = __webpack_public_path__ + "static/img/no_data.b8c100b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/no_data.png
// module id = OjLq
// module chunks = 0